import axios from "axios";
import QRCode from 'qrcode'
import { useCallback, useEffect, useRef, useState } from "react";
import { Attendance, QrStatus, ResponseCode } from "iasma-datatypes";
import { checkAttendance, createAttendance } from "@/services/EventService";
import { useAuth } from "@/contexts/AuthContext";
import { useNotify } from "@/contexts/NotifyContext";
import { NavBack } from "../layout/Menu/NavBack";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export default function ShowQR({ eventId }: { eventId: number }) {

	const navigate = useNavigate();
	const { setToken } = useAuth();
	const { setNotify } = useNotify();
	const [attendance, setAttendance] = useState<Attendance | undefined>(undefined)
	const [secondsLeft, setSecondsLeft] = useState(0);
	const [eventDescription, setEventDescription] = useState<string | undefined>(undefined)
	const [eventLocation, setEventLocation] = useState<string | undefined>(undefined)
	const pollRef = useRef<number | null>(null);
	const tickRef = useRef<number | null>(null);
	const canvasRef = useRef<HTMLCanvasElement>(null)
	const size = 320;

	const clearTimers = () => {
		if (pollRef.current) window.clearInterval(pollRef.current);
		if (tickRef.current) window.clearInterval(tickRef.current);
	};

	const startSession = useCallback(async () => {
		clearTimers();
		setNotify(null);
		try {
			setToken(axios);
			let result: Attendance = await createAttendance(eventId);
			console.log("createAttendance", result);
			setAttendance(result);
			setEventDescription(result.EventDescription)
			setEventLocation(result.EventLocation)
			if (result.Status === ResponseCode.Success) {
				setSecondsLeft(result.QrSecondsLeft!)

				pollRef.current = window.setInterval(async () => {
					try {
						const latest: Attendance = await checkAttendance(eventId);
						setAttendance(latest);
						if (latest.QrStatus) {
							if (latest.QrStatus === QrStatus.Expired) {
								clearTimers();
							} else if (latest.QrStatus === QrStatus.Verified) {
								clearTimers();
							} else {

							}
						}
					} catch {
						// transient network error - keep polling
					}
				}, 2000);

				// Local countdown for the UI.
				tickRef.current = window.setInterval(() => {
					setSecondsLeft((prev) => {
						if (prev <= 1) {
							setAttendance(prev => prev ? ({
								...prev,
								QrStatus: QrStatus.Expired
							}) : undefined);
							clearTimers();
							return 0;
						}
						return prev - 1;
					});
				}, 1000);

			} else if (result.Status === ResponseCode.AlreadyAttend) {
				// result.AttendanceDate = rec.AttendanceDate;
				// result.AttendanceTime = rec.AttendanceTime;
				// result.VerificationMode = rec.VerificationMode;
				// result.VerifiedBy = rec.VerifiedBy
				// setAttendanceCode("")
				// setAttendanceTime(result.AttendanceTime);
			}
		} catch (error) {
			setNotify({ title: "Generate QR Gagal", error, severity: 'error' });
		}
	}, [])

	useEffect(() => {
		startSession();
		return clearTimers;
	}, [startSession]);

	useEffect(() => {
		const canvas = canvasRef.current
		if (!canvas) return

		if (!attendance || !attendance.QrCode || !attendance.QrCode.trim()) {
			const ctx = canvas.getContext('2d')
			ctx?.clearRect(0, 0, canvas.width, canvas.height)
			return

		} else {
			QRCode.toCanvas(canvas, attendance.QrCode, {
				width: size,
				margin: 2,
				errorCorrectionLevel: 'medium',
				color: {
					dark: '#14213D',
					light: '#F6F5F1'
				}
			}).then(() => {

			}).catch((error) => {
				setNotify({ title: "Generate QR Gagal", error, severity: 'error' });
			})
		}
	}, [attendance?.QrCode])

	function showContent() {
		let result = null;
		if (attendance) {
			if ([ResponseCode.AlreadyAttend, ResponseCode.CodeVerified].includes(attendance.Status)) {
				// result = <div>
				// 	<span>Sudah absensi pada {attendanceTime}</span>
				// </div>
				result = <div className="flex flex-col items-center py-6">
					<h1 className="mt-2 text-md font-semibold text-slate-800 text-center mb-4">
						{eventDescription} di {eventLocation}
					</h1>
					<div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center">
						<svg
							className="h-8 w-8 text-emerald-600"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							strokeWidth={2.5}
						>
							<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
						</svg>
					</div>
					<h2 className="mt-4 text-xl font-semibold text-slate-900">
						{attendance.Status === ResponseCode.AlreadyAttend ? "Sudah Absensi" : "Verifikasi berhasil"}
					</h2>
					<h1 className="mt-2 text-md text-slate-500 text-center">
						pada {attendance.AttendanceDT}
					</h1>
					<p className="text-sm text-slate-500 text-center mb-4">
						oleh {attendance.VerifiedBy}
					</p>
					<Button
						variant={"default"}
						onClick={() => navigate(-1)}
					>
						kembali
					</Button>

				</div>
			} else if (attendance.QrStatus === QrStatus.Pending) {
				const mm = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
				const ss = String(secondsLeft % 60).padStart(2, "0");
				result = <div className="flex flex-col items-center py-6">
					<h1 className="text-2xl font-semibold text-slate-900 text-center">
						Verifikasi Indentitas Anda
					</h1>
					<p className="text-slate-500 text-center mt-2 mb-4 text-sm">
						tunjukan kode QR ini pada panitia absensi.
					</p>

					<h1 className="mt-2 text-md font-semibold text-slate-800 text-center mb-4">
						{eventDescription} di {eventLocation}
					</h1>
					<canvas ref={canvasRef} className="p-1 border border-slate-200 rounded-xl" />
					<div className="mt-4 flex items-center gap-2">
						<span className="relative flex h-2.5 w-2.5">
							<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
							<span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-amber-500" />
						</span>
						<span className="text-sm text-slate-600">
							kadaluarsa dalam {mm}:{ss}
						</span>
					</div>
				</div>
			} else if (attendance.QrStatus === QrStatus.Expired) {
				result = <div className="flex flex-col items-center py-6">
					<div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center">
						<svg
							className="h-8 w-8 text-red-600"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							strokeWidth={2.5}
						>
							<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</div>
					<h2 className="mt-4 text-lg font-semibold text-slate-900">
						QR Kadaluarsa
					</h2>
					<button
						onClick={startSession}
						className="mt-4 px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition"
					>
						Buat QR baru
					</button>
				</div>
			}

		}
		return result;
	}

	return (<div className="flex flex-col items-center py-4">
		<NavBack />
		<div className="w-full max-w-md bg-white rounded-2xl shadow-xl border p-6 justify-center ">
			{showContent()}
		</div>
	</div>)
}



